import { jsx as n, jsxs as m, Fragment as F } from "react/jsx-runtime";
import t from "classnames";
import "./main.scss";
import { Badge as y } from "@strata/react-status-icons";
import { useState as C, useEffect as A, Fragment as L } from "react";
const _ = ({
  mainContent: e = void 0,
  className: i = void 0
}) => /* @__PURE__ */ n("div", { className: t("sds_form__content-container", i), children: e }), v = ({
  rowOneContentHeader: e = void 0,
  rowTwoContentHeader: i = void 0,
  rowThreeContentHeader: s = void 0,
  rowFourContentHeader: r = void 0
}) => e ?? i ?? s ?? r ? /* @__PURE__ */ m("div", { className: "sds_form__page-container__header", children: [
  e && /* @__PURE__ */ n("div", { className: "sds_form-header__row-container", children: e }),
  i && /* @__PURE__ */ n("div", { className: "sds_form-header__row-container", style: { alignItems: "flex-end" }, children: i }),
  s && /* @__PURE__ */ n("div", { className: "sds_form-header__row-container", style: { alignItems: "flex-end" }, children: s }),
  r && /* @__PURE__ */ n("div", { className: "sds_form-header__row-container", style: { alignItems: "flex-end" }, children: r })
] }) : null, f = ({ children: e }) => /* @__PURE__ */ n("div", { className: "sds_form__page-container", children: e }), B = ({
  rowOneContentHeader: e,
  rowTwoContentHeader: i,
  rowThreeContentHeader: s,
  rowFourContentHeader: r,
  className: o,
  mainContent: c
}) => /* @__PURE__ */ m(f, { children: [
  /* @__PURE__ */ n(
    v,
    {
      rowOneContentHeader: e,
      rowTwoContentHeader: i,
      rowThreeContentHeader: s,
      rowFourContentHeader: r
    }
  ),
  /* @__PURE__ */ n(_, { className: o, mainContent: c })
] }), p = ({
  rowOneContent: e = void 0,
  rowTwoContent: i = void 0,
  rowThreeContent: s = void 0,
  rowFourContent: r = void 0,
  className: o
}) => /* @__PURE__ */ n(
  _,
  {
    className: o,
    mainContent: /* @__PURE__ */ m(F, { children: [
      e && /* @__PURE__ */ n("div", { className: "sds_form__row-container", children: e }),
      i && /* @__PURE__ */ n("div", { className: "sds_form__row-container", children: i }),
      s && /* @__PURE__ */ n("div", { className: "sds_form__row-container", children: s }),
      r && /* @__PURE__ */ n("div", { className: "sds_form__row-container", children: r })
    ] })
  }
), D = ({
  rowOneContentHeader: e,
  rowTwoContentHeader: i,
  rowThreeContentHeader: s,
  rowFourContentHeader: r,
  rowOneContent: o,
  rowTwoContent: c,
  rowThreeContent: l,
  rowFourContent: d
}) => /* @__PURE__ */ m(f, { children: [
  /* @__PURE__ */ n(
    v,
    {
      rowOneContentHeader: e,
      rowTwoContentHeader: i,
      rowThreeContentHeader: s,
      rowFourContentHeader: r
    }
  ),
  /* @__PURE__ */ n(
    p,
    {
      rowOneContent: o,
      rowTwoContent: c,
      rowThreeContent: l,
      rowFourContent: d
    }
  )
] }), I = (e) => e.mainContent ?? e.rowOneContent ?? e.rowTwoContent ?? e.rowThreeContent ?? e.rowFourContent, x = (e, i) => {
  if (!e)
    return 0;
  const s = i.findIndex(
    (r) => e.toLocaleLowerCase() === r.title.toLocaleLowerCase()
  );
  return s !== -1 && I(i[s]) ? s : 0;
}, K = ({
  rowOneContentHeader: e,
  rowTwoContentHeader: i,
  rowThreeContentHeader: s,
  rowFourContentHeader: r,
  tabs: o,
  activeTab: c = void 0,
  onTabSelect: l = void 0
}) => {
  const [d, h] = C(x(c, o));
  return A(() => {
    h(x(c, o));
  }, [c, o]), /* @__PURE__ */ m(f, { children: [
    /* @__PURE__ */ n(
      v,
      {
        rowOneContentHeader: e,
        rowTwoContentHeader: i,
        rowThreeContentHeader: s,
        rowFourContentHeader: r
      }
    ),
    /* @__PURE__ */ n("div", { className: "sds_form-navbar", children: o.map((a, N) => {
      const g = () => {
        l == null || l(a.title), h(N);
      };
      return I(a) && /* @__PURE__ */ m(L, { children: [
        /* @__PURE__ */ n(
          "div",
          {
            role: "button",
            title: a.title,
            className: t("sds_form-navbar__tab", {
              "sds_form-navbar__tab--active": N === d
            }),
            onKeyDown: (u) => {
              u.key === "Enter" && g();
            },
            onClick: g,
            tabIndex: 0,
            children: a.title
          }
        ),
        /* @__PURE__ */ n("div", { style: { position: "relative" }, children: /* @__PURE__ */ n(y, { count: a.badgeCount, intent: a.badgeIntent }) })
      ] }, a.title);
    }) }),
    o[d] && (o[d].mainContent ? /* @__PURE__ */ n(
      _,
      {
        ...o[d],
        className: t(o[d].className)
      }
    ) : /* @__PURE__ */ n(
      p,
      {
        ...o[d],
        className: t(o[d].className)
      }
    ))
  ] });
};
export {
  B as FormHeaderAndContent,
  D as FormHeaderAndRowContent,
  K as FormHeaderAndTabbedContent,
  f as FormPageContainer
};
//# sourceMappingURL=index.js.map
